import { c as _c } from "react/compiler-runtime";
import useIsBrowser from 'hooks/useIsBrowser';
import { useMediaQuery } from 'react-responsive';

// Note: It is impossible to accurately determine whether the device is a hover
// device on the server side, so we always return false from this hook until
// the component has mounted in the browser.
const useIsHoverDevice = () => {
  const $ = _c(1);
  const isBrowser = useIsBrowser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      query: "(hover: hover)"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isHoverDevice = useMediaQuery(t0);
  return isBrowser && isHoverDevice;
};
export default useIsHoverDevice;